import React from 'react';

function Maintenance() {
  return (
    <div className="error-page">
      <div className="error-container">
        <h1>🔧</h1>
        <h2>System under update</h2>
        <p>Please check back soon.</p>
      </div>
    </div>
  );
}

export default Maintenance;
